import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PostcodeLookupServiceInterface } from '../postcode-lookup-service-interface';
import { SessionService } from '../../session.service';

@Injectable()
export class FetchifyProvider implements PostcodeLookupServiceInterface {
    private api_url: string = environment.api_url;

    constructor(private http_client: HttpClient, private session_service: SessionService) {}

    searchAddress(search_term: string): Observable<any> {
        const headers = new HttpHeaders({
            Domain: this.session_service.domain,
        });

        const url = new URL(`${this.api_url}core/postcode-lookup/get-suggested-addresses/fetchify/${search_term}`);
        const response = this.http_client.get(url.toString(), {headers: headers});

        return response;
    }

    getAddressById(id: string): Observable<any> {
        const headers = new HttpHeaders({
            Domain: this.session_service.domain,
        });

        const url = new URL(`${this.api_url}core/postcode-lookup/get-address/fetchify/${id}`);
        const response = this.http_client.get(url.toString(), {headers: headers});

        return response;
    }

    formatSuggestedAddresses(suggestedAddresses): string[] {
        return suggestedAddresses.results
            .filter(item => item.count === 1)
            .map(item => ({
                id: item.id,
                text: item.labels.join(', '),
            }));
    }

    formatAddress(address): any {
        const addr = address.result;

        const residential = addr.type.toLowerCase().includes('residential');
        const street = addr.street_prefix + ' ' + addr.street_name + ' ' + addr.street_suffix;

        return {
            line1: addr.line_1,
            line2: addr.line_2,
            line3: addr.line_3,
            city: addr.locality,
            county: addr.province_name,
            postcode: addr.postal_code,
            company: addr.company_name,
            street: street.trim(),
            buildingNumber: addr.building_number,
            buildingName: addr.building_name,
            subBuilding: addr.sub_building_name,
            residential: residential,
            businessBuildingName:  residential == false && addr.building_name ?  addr.company_name + ', ' +  addr.building_name : addr.line_1,
        };
    }
}